import React from 'react';
import { useGetList } from 'react-admin';
import { Link } from 'react-router-dom';
import {
	Card,
	CardContent,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Typography,
} from '@mui/material';

// LastUsers : les 10 dernières inscriptions.
//
// ⚠️ Tri sur `id` et non sur la date de création : la colonne s'appelle
// `createdAt` en camelCase, et le tri est injecté tel quel dans le SQL — sans
// guillemets doubles, Postgres la replierait en `createdat` et la requête
// échouerait. L'id est auto-incrémenté, son ordre est donc chronologique.
export const LastUsers: React.FC = () => {
	const { data, isLoading, error } = useGetList('users', {
		pagination: { page: 1, perPage: 10 },
		sort: { field: 'id', order: 'DESC' },
	});

	const label = (u: any) =>
		[u.firstname, u.lastname].filter(Boolean).join(' ') || u.name || '(sans nom)';

	return (
		<Card sx={{ height: '100%' }}>
			<CardContent>
				<Typography variant="h6" gutterBottom>
					Dernières inscriptions
				</Typography>
				{error && (
					<Typography variant="body2" color="error">
						Chargement impossible
					</Typography>
				)}
				{isLoading && !error && (
					<Typography variant="body2" color="text.secondary">
						Chargement…
					</Typography>
				)}
				{!isLoading && !error && !data?.length && (
					<Typography variant="body2" color="text.secondary">
						Aucune inscription
					</Typography>
				)}
				{!!data?.length && (
					<Table size="small">
						<TableHead>
							<TableRow>
								<TableCell>Utilisateur</TableCell>
								<TableCell>Email</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{data.map((u: any) => (
								<TableRow key={u.id} hover>
									<TableCell>
										<Link to={`/users/${u.id}`}>{label(u)}</Link>
									</TableCell>
									<TableCell>{u.email || '—'}</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				)}
				<Typography variant="caption" sx={{ display: 'block', mt: 1 }}>
					<Link to="/users">Voir tous les utilisateurs</Link>
				</Typography>
			</CardContent>
		</Card>
	);
};
